/**
 * Which v1 `viko.project.yaml` machine key (`machines.allowed`, `repos[].paths`) an enrolled
 * machine is, for projects not yet moved to machine-local checkouts. The daemon's own answer (its
 * encrypted `machine.projects` report) is authoritative; without one: machine id, normalized
 * name, then name prefix. account-projects removed the hub-side slug mapping: checkouts replace it.
 */
import type { Machine } from './types.js'

type MachineRef = Pick<Machine, 'id' | 'name'> & { configKey?: string }

const norm = (s: string) =>
  s
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')

export function machineConfigKey(allowed: readonly string[], m: MachineRef): string | undefined {
  if (m.configKey) return allowed.includes(m.configKey) ? m.configKey : undefined
  const keys = [m.id, norm(m.name)]
  for (const k of keys) if (allowed.includes(k)) return k
  return allowed.find((k) => norm(m.name).startsWith(k))
}
